import styled from "styled-components"

export const AboutMeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;

  .gatsby-image-wrapper {
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
  }

  h3 {
    text-align: right;
    margin: 20px 0;
  }

  p {
    line-height: 1rem;
    letter-spacing: 0.1em;
    margin-bottom: 20px;
    font-size: .7rem;
  }

  ul {
    display: flex;
  }

  ul,
  ul li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  ul li a svg {
    fill: ${({ theme }) => theme.colors.darkGreen};
    width: 20px;
    height: 20px;
    & :hover {
      fill: ${({ theme }) => theme.colors.lightGreen};
      transition: ease 0.5s;
    }
  }

  ul li:not(:last-child) {
    margin-right: 10px;
  }

  @media (max-width: 950px) {
    margin: 0 20px;
  }
`
